/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NetCloudCheckIcon20Solid = forwardRef('NetCloudCheckIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.89 7.265A5.502 5.502 0 0 1 14.15 6.002 5.5 5.5 0 0 1 14 17H5.5a5 5 0 0 1-1.61-9.735Zm10.319 2.593a1 1 0 0 0-1.414-1.415l-3.9 3.9-1.69-1.69a1 1 0 0 0-1.414 1.415l1.69 1.69a2 2 0 0 0 2.828 0l3.9-3.9Z" })));
});
